const __HTTP_VALIDATION_FAILED = 422; // Laravel validation failed
const __HTTP_BAD_REQUEST = 400; // Bad Request
const __HTTP_UNAUTHORIZED = 401; // Unauthorized : Authentication credentials for the target resource.
const __HTTP_TOKEN_MISMATCH = 419; // The page has expired due to inactivity.

/**
 * Application specific code
 */
let $app = {
    /**
     * has from lodash
     * @param object
     * @param key
     * @returns {boolean}
     */
    has: function (object, key) {
        return object != null && Object.prototype.hasOwnProperty.call(object, key)
    },

    /**
     * isObject from lodash
     * @param value
     * @returns {boolean}
     */
    isObject: function (value) {
        const type = typeof value
        return value != null && (type == 'object' || type == 'function')
    },

    /**
     * Display server response message
     * @param response
     */
    commonDoneResponseMessage: function (response) {
        let message = $app.has(response, 'message') ? response.message : null;
        if (message) {
            toastr["success"](message);
        }
    },

    buttonLoading: function (btnName, isDisable, label) {
        let __indef;
        let btnSave = $('.' + btnName);
        btnSave.prop("disabled", isDisable);
        if (isDisable) {
            let buttonLabel = label === __indef ? 'Please wait...' : label;
            btnSave.html('<i class="fas fa-spinner fa-spin mr-1"></i>' + buttonLabel);
        } else {
            let buttonLabel = label === __indef ? 'Submit' : label;
            btnSave.html(buttonLabel);
        }
    },

    /**
     * Process fail response,
     * e.g. laravel validation error, other fail errors.
     * @param jqXHR
     */
    commonFailResponseMessage: function (jqXHR) {
        let status = $app.has(jqXHR, 'status') ? jqXHR.status : null;
        switch (status) {
            case __HTTP_VALIDATION_FAILED:
                let errorResponse = $app.has(jqXHR, 'responseText') ? $.parseJSON(jqXHR.responseText) : 'Validation failed, please try again.';
                let errorsHtml = '<ul class="list-unstyled">';
                if ($app.has(errorResponse, 'errors')) {
                    $.each(errorResponse.errors, function (key, error) {
                        errorsHtml += '<li>' + error[0] + '</li>';
                    });
                }
                errorsHtml += '</ul>';
                toastr["error"](errorsHtml);
                break;
            case __HTTP_BAD_REQUEST:
                let errorMessage = $app.has(jqXHR, 'responseText') ? $.parseJSON(jqXHR.responseText) : 'Bad request, please try again.';
                if ($app.isObject(errorMessage)) {
                    errorMessage = $app.has(errorMessage, 'message') ? errorMessage.message : 'Bad request, please try again.';
                }
                toastr["error"](errorMessage);
                break;
            case __HTTP_UNAUTHORIZED:
                let message = 'You are not logged in. Please login and try again';
                toastr["error"](message);
                break;
            case __HTTP_TOKEN_MISMATCH:
                let tokenMismatch = 'The page has expired due to inactivity. Please refresh the page and try again.';
                toastr["error"](tokenMismatch);
                break;
            default:
                toastr["error"]("Oops! Something went wrong, please try again.");
        }
    }
};

// export this module to make it available to others
module.exports = $app;

/**
 * Application specific code
 */

$(document).ready(function () {
    var __indef; // undefined
    var __milliSeconds = 15999; // default time for message disappear

    /**
     * remove Alert after some time
     *
     * @param {number} milliSeconds
     * @returns {undefined}
     */
    function removeAlert(milliSeconds) {
        if (milliSeconds === __indef)
            milliSeconds = __milliSeconds;

        // hide flash message after some time
        window.setTimeout(function () {
            $("#app-error").fadeTo(500, 0).slideUp(500, function () {
                $(this).remove();
            });
        }, milliSeconds);

        // window.scrollTo(0, document.body.scrollHeight);
    }

    // call alert function to hide alert message
    removeAlert(__milliSeconds);

    /**
     * Initialize the bootstrap-select
     */
    $('.selectpicker').selectpicker({
        size: 7,
        dropupAuto: false
    });

    $('[data-toggle="popover"]').popover({
        // trigger: 'click',
        delay: {"show": 0, "hide": 0},
        placement: 'auto',
        html: true
    });

    /**
     * Avoid Google Map submitting the form
     *
     */
    $(".google-address").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    /**
     * Set the avatar-modal form action URL
     */
    $(document).on("click", '[data-target="#avatar-modal"]', function () {
        var formAction = $(this).attr('data-action');
        $('form.avatar-form').attr('action', formAction);
    });

    /**
     * This is backstretch image display
     */
    var header_height = $('#header').height();

    // parallax header
    function parallax() {
        var scrolled = $(window).scrollTop();
        $('#header .backstretch img').css('top', '' + -(scrolled * 0.5) + 'px');
        $('.heading').css('background-position', 'center ' + -(scrolled * 0.5) + 'px');
    }

    // navbar & adjust the background images
    $(window).scroll(function () {
        parallax();
        if ($(window).scrollTop() > header_height) {
            // $('.navbar').css('border-bottom-color', '#3bafda');
        } else {
            // $('.navbar').css('border-bottom-color', '#fff');
        }
    });

    /**
     * Datepicker init function
     */
    $('#birth_date').datepicker({
        format: "dd/mm/yyyy",
        autoclose: true,
        orientation: "bottom auto",
        maxViewMode: 2,
        endDate: '+0m',
        keyboardNavigation: true
    });

    /**
     * toastr options
     */
    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "500",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
});
